import dashboard from './reducers';

export {default as dashboardActions} from './actions';
export {default as dashboardTypes}   from './types';

export default dashboard;